/**
 * How an order's status and source are shown to staff. Shared by the Orders page
 * and the Customers area so the two can never use different wording or colours.
 */

const SOURCE_LABEL_KEYS = {
  webshop: "storefrontOrders.channelWebshop",
  instagram: "storefrontOrders.channelInstagram",
  facebook: "storefrontOrders.channelFacebook",
  phone: "storefrontOrders.channelPhone",
  other: "storefrontOrders.channelOther",
};

/**
 * The single place that turns persisted status + shipment state into the label
 * staff see. "Në dërgesë" is derived, never stored.
 */
export function resolveOrderDisplayStatus(order) {
  const orderStatus = String(order?.orderStatus || "").toLowerCase();
  const shipmentStatus = String(order?.shipmentStatus || "").toLowerCase();

  if (orderStatus === "cancelled") {
    return { key: "cancelled", labelKey: "storefrontOrders.statusCancelled", tone: "cancelled" };
  }

  if (orderStatus === "returned_to_sender") {
    return {
      key: "returned_to_sender",
      labelKey: "storefrontOrders.statusReturnedToSender",
      tone: "returned",
    };
  }

  if (orderStatus === "delivered") {
    return { key: "delivered", labelKey: "storefrontOrders.statusDelivered", tone: "delivered" };
  }

  if (orderStatus === "confirmed") {
    if (shipmentStatus === "created" || shipmentStatus === "requested") {
      return {
        key: "in_delivery",
        labelKey: "storefrontOrders.statusInDelivery",
        tone: "in-delivery",
      };
    }

    return { key: "confirmed", labelKey: "storefrontOrders.statusConfirmed", tone: "confirmed" };
  }

  return { key: "new", labelKey: "storefrontOrders.statusNew", tone: "new" };
}

export function resolveOrderSourceLabel(t, order) {
  const channel = String(order?.orderChannel || "").toLowerCase();
  if (channel && SOURCE_LABEL_KEYS[channel]) {
    return t(SOURCE_LABEL_KEYS[channel]);
  }

  return String(order?.sourceChannel || "").toLowerCase() === "storefront"
    ? t("storefrontOrders.channelWebshop")
    : t("storefrontOrders.channelOther");
}
